import { Injectable } from '@angular/core';
import { ReferenceAreaDataService } from '../../reference-areas/services/reference-area-data.service';
import { ReportingDataService } from './reporting-data.service';
import { TrainScheduleDataService } from '../../train-schedules/services/train-schedule-data.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class QueryWordsDataService {

  constructor(
    private referenceAreaService: ReferenceAreaDataService,
    private reportingDataService: ReportingDataService, 
    private trainScheduleDataService: TrainScheduleDataService
    // advancedQueryResourceService
    // trainScheduleResourceService
  ) { }

  getWords = async (projectId: number) => {
    const words: any = {
      ids: [],
      values: [],
      mathOperators: [],
      operators: [],
      valids: new Map()
    };
    const waypoints = await this.referenceAreaService.getReferenceAreas(projectId).pipe(
                          map(referenceAreas => referenceAreas.filter(area => area.type === 'WAYPOINT'))).toPromise();
    
    words.values = [...new Set(waypoints.map(waypoint => waypoint.abbreviation).filter(abbr => !!abbr))];
    words.valids.set("START_STATION", words.values.slice(0));
    words.valids.set("END_STATION", words.values.slice(0));

    const days = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
    words.values = [
      ...words.values,
      ...days
    ];
    words.valids.set("DAY", days);

    const sqis = await this.reportingDataService.getAdvancedQuerySQIs(projectId).toPromise();
    words.ids.push("START_STATION");
    words.ids.push("END_STATION");
    words.ids.push("DAY");
    words.ids.push("DEPARTURE_TIME");
    words.ids.push("ARRIVAL_TIME");
    words.ids.push("SERVICE_ID");
    words.ids.push("FAILED_TRIPS")
    for (let index = 0; index < sqis.length; index++) {
      const sqi = sqis[index];
      const title = sqi.title && sqi.title.toUpperCase().replace(" ", "_"); // TODO it was replaceAll. Check if replace is enough
      if (!words.ids.find(id => id === title)) {
        words.ids.push(title);
      }
    }
    
    const trainSchedules = await this.trainScheduleDataService.getTimetable(projectId).toPromise();
    const validServiceIds = trainSchedules.map(schedule => schedule.serviceId).filter(serviceId => !!serviceId);
    words.valids.set("SERVICE_ID", [...new Set(validServiceIds)]);

    words.mathOperators.push("==");
    words.mathOperators.push("=");
    words.mathOperators.push(">=");
    words.mathOperators.push("<=");
    words.mathOperators.push("!=");
    words.mathOperators.push(">");
    words.mathOperators.push("<");

    words.operators.push("AND");
    words.operators.push("OR");

    return words;
  }
}
